import { Footer } from '../homepage/Footer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrivacyMessages as m } from './PrivacyPage.messages';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import './static-page.css';

export const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
    <PageSeo
      path="/privacy"
      titleKey="seo.privacy.title"
      descriptionKey="seo.privacy.description"
      noindex
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Privacy', path: '/privacy' }])]}
    />
    <div className="page-wrapper"><div className="static-page">
      <h1>{t(m.PAGE_TITLE)}</h1>
      <p className="page-subtitle">{t(m.SUBTITLE)}</p>

      <h2>{t(m.WHAT_WE_COLLECT_TITLE)}</h2>
      <ul>
        <li>{t(m.COLLECT_ITEM_1)}</li>
        <li>{t(m.COLLECT_ITEM_2)}</li>
        <li>{t(m.COLLECT_ITEM_3)}</li>
        <li>{t(m.COLLECT_ITEM_4)}</li>
      </ul>

      <h2>{t(m.HOW_WE_USE_TITLE)}</h2>
      <ul>
        <li>{t(m.USE_ITEM_1)}</li>
        <li>{t(m.USE_ITEM_2)}</li>
        <li>{t(m.USE_ITEM_3)}</li>
        <li>{t(m.USE_ITEM_4)}</li>
      </ul>

      <h2>{t(m.HOW_WE_PROTECT_TITLE)}</h2>
      <ul>
        <li>{t(m.PROTECT_ITEM_1)}</li>
        <li>{t(m.PROTECT_ITEM_2)}</li>
        <li>{t(m.PROTECT_ITEM_3)}</li>
        <li>{t(m.PROTECT_ITEM_4)}</li>
      </ul>

      <h2>{t(m.THIRD_PARTIES_TITLE)}</h2>
      <ul>
        <li dangerouslySetInnerHTML={{ __html: t(m.THIRD_PARTY_BEDROCK) }} />
        <li dangerouslySetInnerHTML={{ __html: t(m.THIRD_PARTY_STRIPE) }} />
        <li dangerouslySetInnerHTML={{ __html: t(m.THIRD_PARTY_AWS) }} />
      </ul>

      <h2>{t(m.YOUR_RIGHTS_TITLE)}</h2>
      <p>{t(m.YOUR_RIGHTS_DESC)}</p>

      <h2>{t(m.CONTACT_TITLE)}</h2>
      <p dangerouslySetInnerHTML={{ __html: t(m.CONTACT_DESC) }} />

      <p className="last-updated">{t(m.LAST_UPDATED)}</p>
    </div>
    <Footer />
    </div>
    </>
  );
};
